import PrudctsAndOffersTable from './ProductsAndOffersTable.module';
export default PrudctsAndOffersTable;
